import { SUB_COMPANIES_ACTION_TYPE } from '../actions';

const initialState = [];

const subCompaniesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUB_COMPANIES_ACTION_TYPE.GET_SUB_COMPANIES:
      return payload;

    case SUB_COMPANIES_ACTION_TYPE.UPDATE_SUB_COMPANY:
    case SUB_COMPANIES_ACTION_TYPE.GET_SUB_COMPANY_BY_ID:
      return [...state.filter(({ id }) => payload.id !== id), payload];

    case SUB_COMPANIES_ACTION_TYPE.RESET_SUB_COMPANIES_STATE:
      return initialState;

    default:
      return state;
  }
};

export default subCompaniesReducer;
